import { createHttpLink } from "@apollo/client/link/http";

export default () => {
  const baseUrl = "/graphql";
  const uri = operation => `${baseUrl}?op=${operation.operationName}`;

  return createHttpLink({
    uri
  });
};
